import { LIST_DATE_FORMAT, LIST_TIME_FORMAT } from '@app/utils/dates/dateFormats';
import { BaseColumn, TableRow } from '@konnecta/generic-table';
import { Typography } from 'antd';
import type { TFunction } from 'i18next';
import { DateTimeDisplay } from './DateTimeDisplay';

type WithCreatedAt = TableRow & { createdAt?: string | null };

// Every list endpoint allows sort=created_at.
export const createdAtColumn = <T extends WithCreatedAt>(t: TFunction): BaseColumn<T> => ({
  id: 'createdAt',
  header: t('common-col-created-on'),
  accessor: 'createdAt',
  align: 'left',
  width: 180,
  sortable: true,
  sortField: 'created_at',
  cellRenderer: (_, row) =>
    row.createdAt ? (
      <DateTimeDisplay
        startTime={row.createdAt}
        showDateSeparately={false}
        dateFormat={LIST_DATE_FORMAT}
        timeFormat={LIST_TIME_FORMAT}
        timeClassName="text-gray-600"
      />
    ) : (
      <Typography.Text>-</Typography.Text>
    ),
});
